import { FaArrowRightLong } from "react-icons/fa6";
import "./ListaSistemasModal.css";
import { EnumSistemas } from "../../utils/EnumsUtils";

const ListaSistemasModal = (
    { onSelecionarSistema = () => {} }
) => {
    const sistemas = Object.values(EnumSistemas);

    return (
      <div className="modal-sistemas-lista">
        <hr className="divisor" />
        {sistemas.map((nome, idx) => (
          <button
            key={nome}
            className="modal-sistemas-item"
            onClick={() => onSelecionarSistema({ nome })}
          >
            <div className="modal-sistemas-item-wrapper">
              <div className="modal-sistemas-item-conteudo">
                <span>{nome}</span>
                <FaArrowRightLong size={22} />
              </div>
              <hr className="divisor" />
            </div>
          </button>
        ))}
      </div>
    );
}

export default ListaSistemasModal;

